"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIDescription = isIDescription;
function isIDescription(item) {
    return item && item.text && typeof (item.text) === 'string';
}
